/*
 * getValueDeep.ts
 *
 * Created by Dr. Maximillian Dornseif 2021-08-27 in huWaWi3 23.3.2
 * Copyright (c) Dr. Maximillian Dornseif
 */

import * as R from 'ramda'

// irgendwo - im Zweifel ganz unten - einen key aus der Entity Hierachie rauslesen
export function getValueDeep<T>(key: string | Symbol, obj): T | undefined {
  return Object.values(getPathsDeep(key, obj)).pop() as T | undefined
}

export function getPathsDeep<T>(key: string | Symbol, obj, path = ''): Record<string, T> {
  const ret: any[] = []
  for (const i in obj) {
    // wenn ererbt, wollen wir das nicht
    if (!Object.prototype.hasOwnProperty.call(obj, i)) {
      continue
    }
    // wenn es passt, liefern wir zurück
    if (i === key) {
      ret.push({ [`${path}${i}`.replace('.[', '[')]: obj[i] })
    }
    const accessor = Number.isInteger(parseInt(i)) ? `[${i}].` : `${i}.`
    if (typeof obj[i] === 'object') {
      // ansonsten rekursion versuchen
      const found = getPathsDeep(key, obj[i], `${path}${accessor}`.replace('.[', '['))
      if (found) {
        ret.push(found)
      }
    }
  }
  return R.mergeAll(ret.flat())
}
